import React from 'react';
import ProductItemView from '../ProductItemView';
import centralized_service from '../../resource/middleware/centralized_service.svg';


const CentralizedService = () => {
    return (
        <ProductItemView
            title="Servicio centralizado"
            items={["Consumo de recursos optimizado", "Windows / Linux compatible", "Agregar una conexión a Middleware es un proceso corto, simple"]}
            image={centralized_service}
            centered />
    );
};

export default CentralizedService;